module.exports = __webpack_public_path__ + "static/media/gucci.dd627b9c.jpg";